import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
//import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    //.use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'uk',
        supportedLngs: ['uk', 'en'],
        backend: {
            loadPath: '/assets/spa/static/locales/%lng%/%ns%.json'
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            prefix: '%',
            suffix: '%',
        },
        react: {
            useSuspense: true
        }
    });


export default i18n;
